import { EventLeadQuickFormModal } from '@/components/layout/EventLeadQuickFormModal'
import { useEventLeadCaptureStore } from '@/stores/eventLeadCaptureStore'

export function MobileEventLeadCapture() {
  const quickFormOpen = useEventLeadCaptureStore((s) => s.quickFormOpen)
  const closeQuickForm = useEventLeadCaptureStore((s) => s.closeQuickForm)

  return (
    <EventLeadQuickFormModal open={quickFormOpen} onClose={closeQuickForm} />
  )
}
